import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface AdminTaskCategorySelectProps {
  value: string;
  onChange: (value: string) => void;
}

const DEFAULT_CATEGORIES = [
  { value: "member", label: "Member-Related" },
  { value: "asset", label: "Asset-Related" },
  { value: "contribution", label: "Contribution-Related" },
  { value: "resolution", label: "Resolution-Related" },
  { value: "documentation", label: "Documentation-Related" },
  { value: "banking", label: "Banking & Finance" },
  { value: "business", label: "Business-Related" },
  { value: "other", label: "Other" },
];

export function AdminTaskCategorySelect({ value, onChange }: AdminTaskCategorySelectProps) {
  const displayLabel =
    DEFAULT_CATEGORIES.find((c) => c.value === value)?.label || value || "Select category";

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue>{displayLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {DEFAULT_CATEGORIES.map((cat) => (
          <SelectItem key={cat.value} value={cat.value}>
            {cat.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
